import { render, staticRenderFns } from "./RiskSearch.vue?vue&type=template&id=28959951&scoped=true&"
import script from "./RiskSearch.vue?vue&type=script&lang=ts&"
export * from "./RiskSearch.vue?vue&type=script&lang=ts&"
import style0 from "./RiskSearch.vue?vue&type=style&index=0&id=28959951&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28959951",
  null
  
)

export default component.exports